import PhoneInput from "../../../../../Inputs/PhoneInput";

export default function Phone({ data = {}, input = {}, onChange = () => { } }) {
  return (
    <PhoneInput
      disabled={input.disabled}
      defaultDialCode={data[input.key]}
      initialValue={data[input.key]}
      onChange={(v) => {
        if (!data[v] && !v) {
          return;
        }
        onChange({ [input.key]: v });
      }}
      allowClear
      country={null}
      size="large"
    />
  );
}
